module.exports = __webpack_public_path__ + "static/media/HCMM898.14d68a55.jpg";